import {
  buildEntityActions,
  buildEntityApi,
  buildEntitySelectors,
} from '@zapier/toolbox-redux-framework';

export const type = 'appDetails';

export const api = buildEntityApi(
  type,
  appTypeAndId => `/api/platform/v3/apps/${appTypeAndId}/details`
);

export const selectors = buildEntitySelectors(type, sel => {
  sel.all.details = (appId, state) => {
    const entity = sel.all.entity(appId, state);
    return sel.isSuccess(entity) ? entity.data : {};
  };
});

export const actions = buildEntityActions(type, selectors, api);
